import React from 'react';
import { OverlayModalComponentProps } from '@sharefiledev/sharefile-appshell';
import { viewEnginePiletOverlays } from '@sharefiledev/view-engine-pilet-sdk';
import { BlockNames } from '../block.types';

const LazyViewByRID = React.lazy(() => import('../components/ViewByRID'));

const defaultFallbackView = {
	blocks: [
		{
			blockRID: '',
			blockName: BlockNames.Text,
			blockParameters: {
				text: {
					en: 'View does not exist',
				},
			},
		},
	],
	rid: '',
	name: 'no-view',
	rootBlockRID: '',
};

export const ViewByRIDDialog: React.FC<
	OverlayModalComponentProps<typeof viewEnginePiletOverlays.viewByRIDDialog>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	if (!options?.viewRID) {
		return <div data-testid="modal-view-by-rid-error" />;
	}
	return (
		<React.Suspense fallback={<div data-testid="loading-modal-view-by-rid" />}>
			<LazyViewByRID
				viewRID={options.viewRID}
				cancelInteraction={cancelInteraction}
				completeInteraction={completeInteraction}
				piletApi={piral}
				fallbackView={options.fallbackView ?? defaultFallbackView}
				contractData={options.contractData}
			/>
		</React.Suspense>
	);
};
